import React from "react";
import { useTranslation } from "../../hooks/useTranslation";

/* Tabela de composição ao lado do gráfico: item (swatch + label), valor da
   métrica e %. Mostra TODOS os itens (a série do gráfico é limitada a
   11+Outros, mas aqui a quebra é completa). */
const CompositionTable = ({
  composition = [], // [{key, label, jobs, pages, cost}]
  colorByKey = {},
  metricKey = "jobs",
  metricLabel = "",
  dimensionLabel = "",
  formatter = (v) => String(v),
  total = 0,
}) => {
  const { t } = useTranslation("consumption");
  const grand = total || composition.reduce((a, c) => a + (c[metricKey] || 0), 0);

  return (
    <table className="mini-table">
      <thead>
        <tr>
          <th>{dimensionLabel}</th>
          <th>{metricLabel}</th>
          <th>%</th>
        </tr>
      </thead>
      <tbody>
        {composition.map((item) => {
          const value = item[metricKey] || 0;
          const pct = grand > 0 ? (value / grand) * 100 : 0;
          return (
            <tr key={item.key}>
              <td>
                <span
                  className="sw"
                  style={{
                    background: colorByKey[item.key] || "var(--ikaro-gray-medium)",
                  }}
                />
                {item.label}
              </td>
              <td>{formatter(value)}</td>
              <td>{pct.toFixed(1)}%</td>
            </tr>
          );
        })}
        {composition.length === 0 && (
          <tr>
            <td colSpan={3} className="mini-empty">
              {t("noData")}
            </td>
          </tr>
        )}
      </tbody>
      <tfoot>
        <tr>
          <td>{t("total")}</td>
          <td>{formatter(grand)}</td>
          <td>100%</td>
        </tr>
      </tfoot>
    </table>
  );
};

export default CompositionTable;
